module.exports = __webpack_public_path__ + "img/img-02.817caaa5.jpg";